import React from "react";
import ReactDOM from "react-dom";
import PrivateInspectionApp from "./ts/PrivateInspectionPortal";
import reportWebVitals from "./ts/reportWebVitals";
import "@tabler/core/dist/css/tabler.css";

ReactDOM.render(
    <React.StrictMode>
        <PrivateInspectionApp />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
